import { put, select, call, takeLatest, all } from 'redux-saga/effects'
import { fromJS } from 'immutable'

import * as Actions from 'actions/ai'
import * as Selectors from 'selectors'
import * as Api from 'api/bff'
import * as AppActions from 'actions/app'

export function* aiAnalysis({ payload }) {
  try {
    const locale = yield select(Selectors.getAiSettingsLocale)
    const prompt = yield select(Selectors.getAiAnalysisPrompt)
    const mode = yield select(Selectors.getAiAnalysisMode)
    const autoDetectMode = yield select(Selectors.getAiAnalysisAutoDetectMode)
    const additionalModes = yield select(Selectors.getAiAnalysisAdditionalModes)

    let news = payload.news || fromJS([])

    news = news.map(n => ({
      id: n.get('id'),
      article_date: n.get('articleDate')
    })).toJS()

    const body = {
      ...payload,
      locale,
      news,
      prompt,
      mode,
      auto_detect_mode: autoDetectMode,
      additional_modes: additionalModes
    }

    const result = yield call(Api.getNewsAiAnalysis, body)

    yield put(Actions.aiAnalysisSuccess(result))
  } catch (error) {
    yield put(Actions.aiAnalysisError(error))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export function* watchAiAnalysis() {
  yield takeLatest(Actions.aiAnalysisStart, aiAnalysis)
}

export default function* shoppingCartSaga() {
  yield all([
    watchAiAnalysis()
  ])
}
